// import React, { useState } from 'react';
// import '../../Styles/AdminLaout.css';

// const ForgotPassword = ({ onBackToLogin }) => {
//   const [email, setEmail] = useState('');
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitted(true);
//   };

//   if (isSubmitted) {
//     return (
//       <div className="login-page">
//         <div className="login-container">
//           <div className="login-header">
//             <h1>Check Your Email</h1>
//             <p>We've sent a password reset link to your email</p>
//           </div>
//           <button 
//             className="back-to-login-btn"
//             onClick={onBackToLogin}
//           >
//             Back to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="login-page">
//       <div className="login-container">
//         <div className="login-header">
//           <h1>Reset Password</h1>
//           <p>Enter your email to receive a reset link</p>
//         </div>
        
//         <form className="login-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="reset-email">Email Address</label>
//             <input
//               type="email"
//               id="reset-email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Enter your email"
//               required
//             />
//           </div>
          
//           <button type="submit" className="login-btn">
//             Send Reset Link
//           </button>
          
//           <div className="login-footer">
//             <button 
//               type="button" 
//               className="back-to-login-btn"
//               onClick={onBackToLogin}
//             >
//               Back to Login
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;

import React, { useState } from 'react';
import { 
  forgotPassword, 
  verifyOtp, 
  resetPassword, 
  resendOtp 
} from '../../Services/Operations/ProductAPI';
import { 
  AlertCircle, 
  CheckCircle, 
  Mail, 
  ArrowLeft,
  Eye,
  EyeOff 
} from 'lucide-react';
import '../../Styles/ForgotPassword.css';

const ForgotPassword = ({ onBackToLogin }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [devOtp, setDevOtp] = useState('');
  const [timer, setTimer] = useState(600);
  
  // Show/hide password states
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Timer logic
  React.useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      
      return () => clearInterval(interval);
    }
  }, [step, timer]);

  // Format time display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Password strength checker
  const getPasswordStrength = (pass) => {
    let score = 0;
    
    // Length check
    if (pass.length >= 8) score++;
    if (pass.length >= 12) score++;
    
    // Character diversity checks
    if (/[A-Z]/.test(pass)) score++;
    if (/[a-z]/.test(pass)) score++;
    if (/[0-9]/.test(pass)) score++;
    if (/[^A-Za-z0-9]/.test(pass)) score++;
    
    return score;
  };

  const passwordStrength = getPasswordStrength(password);
  
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await forgotPassword(email);
      
      if (response.success) {
        setMessage({ 
          type: 'success', 
          text: 'OTP sent to your email!' 
        });
        
        if (response.otp) {
          setDevOtp(response.otp);
        }
        
        setStep(2);
        setTimer(600);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.message || 'Failed to send OTP'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await verifyOtp(email, otp);
      
      if (response.success) {
        setResetToken(response.resetToken);
        setStep(3);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.message || 'Invalid OTP'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setMessage({ type: 'error', text: 'Passwords do not match' });
      return;
    }
    
    if (password.length < 8) {
      setMessage({ type: 'error', text: 'Password must be at least 8 characters' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await resetPassword(resetToken, email, password, confirmPassword);
      
      if (response.success) {
        setMessage({ 
          type: 'success', 
          text: 'Password reset successfully!' 
        });
        
        setTimeout(() => {
          onBackToLogin();
        }, 2000);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.message || 'Failed to reset password'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await resendOtp(email);
      
      if (response.success) {
        setMessage({ 
          type: 'success', 
          text: 'New OTP sent to your email!' 
        });
        
        if (response.otp) {
          setDevOtp(response.otp);
        }
        
        setTimer(600);
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.message || 'Failed to resend OTP'
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle timer expiration
  React.useEffect(() => {
    if (timer === 0 && step === 2) {
      setMessage({ 
        type: 'error', 
        text: 'OTP has expired. Please request a new one.' 
      });
    }
  }, [timer, step]);

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        {/* Back button */}
        <button 
          className="back-button"
          onClick={onBackToLogin}
        >
          <ArrowLeft size={20} />
          Back to Login
        </button>

        {/* Header */}
        <div className="forgot-header">
          <div className="header-icon">
            <Mail size={32} />
          </div>
          <h1>Reset Your Password</h1>
          <p className="subtitle">
            {step === 1 && 'Enter your email to receive an OTP'}
            {step === 2 && 'Enter the OTP sent to your email'}
            {step === 3 && 'Create your new password'}
          </p>
        </div>

        {/* Progress Steps */}
        <div className="progress-steps">
          <div className={`step ${step >= 1 ? 'active' : ''}`}>
            <div className="step-number">1</div>
            <div className="step-label">Enter Email</div>
          </div>
          <div className="step-line"></div>
          <div className={`step ${step >= 2 ? 'active' : ''}`}>
            <div className="step-number">2</div>
            <div className="step-label">Verify OTP</div>
          </div>
          <div className="step-line"></div>
          <div className={`step ${step >= 3 ? 'active' : ''}`}>
            <div className="step-number">3</div>
            <div className="step-label">New Password</div>
          </div>
        </div>

        {/* Message Alert */}
        {message.text && (
          <div className={`alert alert-${message.type}`}>
            {message.type === 'error' ? <AlertCircle size={20} /> : <CheckCircle size={20} />}
            <span>{message.text}</span>
          </div>
        )}

        {/* Development OTP Display */}
        {devOtp && (
          <div className="dev-otp">
            <strong>OTP:</strong> {devOtp}
          </div>
        )}

        {/* Step 1: Email */}
        {step === 1 && (
          <form className="forgot-form" onSubmit={handleSendOtp}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-with-icon">
                <Mail size={20} />
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your registered email"
                  required
                  disabled={loading}
                  autoComplete="email"
                />
              </div>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn"
              disabled={loading || !email}
            >
              {loading ? 'Sending...' : 'Send OTP'}
            </button>
          </form>
        )}

        {/* Step 2: OTP Verification */}
        {step === 2 && (
          <>
            <form className="forgot-form" onSubmit={handleVerifyOtp}>
              <div className="form-group">
                <label>Enter 6-digit OTP</label>
                <div className="otp-input-container">
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength="1"
                      className="otp-digit"
                      value={otp[index] || ''}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        if (value) {
                          const newOtp = otp.split('');
                          newOtp[index] = value;
                          const updatedOtp = newOtp.join('');
                          setOtp(updatedOtp);
                          
                          if (index < 5) {
                            document.querySelectorAll('.otp-digit')[index + 1].focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !otp[index] && index > 0) {
                          document.querySelectorAll('.otp-digit')[index - 1].focus();
                        }
                        if (e.key === 'Delete' && !otp[index] && index < 5) {
                          document.querySelectorAll('.otp-digit')[index + 1].focus();
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pasteData = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
                        if (pasteData.length === 6) {
                          setOtp(pasteData);
                        }
                      }}
                      disabled={loading}
                      autoComplete="one-time-code"
                    />
                  ))}
                </div>
                {/* <p className="otp-hint">
                  We've sent a 6-digit OTP to {email}
                </p> */}
              </div>
              
              <div className="button-group">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={loading || otp.length !== 6 || timer === 0}
                >
                  {loading ? 'Verifying...' : 'Verify OTP'}
                </button>
                <button 
                  type="button"
                  className="resend-btn"
                  onClick={handleResendOtp}
                  disabled={loading}
                >
                  Resend OTP
                </button>
              </div>
            </form>
            
            <div className="timer">
              <div className="timer-text">OTP expires in: </div>
              <div className={`timer-value ${timer < 60 ? 'expiring' : ''}`}>
                {formatTime(timer)}
              </div>
            </div>
          </>
        )}

        {/* Step 3: New Password */}
        {step === 3 && (
          <form className="forgot-form" onSubmit={handleResetPassword}>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                  disabled={loading}
                  autoComplete="new-password"
                />
                <button 
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
              <p className="password-hint">
                Must be at least 8 characters long
              </p>
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                  disabled={loading}
                  autoComplete="new-password"
                />
                <button 
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  disabled={loading}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            
            {/* Password Strength Indicator */}
            {password.length > 0 && (
              <div className="password-strength-container">
                <div className="strength-label">
                  Password Strength:
                  <span className={`strength-text ${passwordStrength <= 2 ? 'weak' : passwordStrength <= 4 ? 'medium' : 'strong'}`}>
                    {passwordStrength <= 2 ? ' Weak' : passwordStrength <= 4 ? ' Medium' : ' Strong'}
                  </span>
                </div>
                <div className="strength-meter">
                  {[1, 2, 3, 4, 5, 6].map((index) => (
                    <div 
                      key={index}
                      className={`strength-segment ${
                        index <= passwordStrength 
                          ? passwordStrength <= 2 
                            ? 'weak' 
                            : passwordStrength <= 4 
                              ? 'medium' 
                              : 'strong'
                          : ''
                      }`}
                    />
                  ))}
                </div>
              </div>
            )}
            
            {/* Password Requirements */}
            <div className="password-requirements">
              <p className="requirements-title">Password must contain:</p>
              <ul>
                <li className={password.length >= 8 ? 'met' : ''}>
                  <span className="checkmark">{password.length >= 8 ? '✓' : '○'}</span>
                  At least 8 characters
                </li>
                <li className={/[A-Z]/.test(password) ? 'met' : ''}>
                  <span className="checkmark">{/[A-Z]/.test(password) ? '✓' : '○'}</span>
                  At least one uppercase letter (A-Z)
                </li>
                <li className={/[a-z]/.test(password) ? 'met' : ''}>
                  <span className="checkmark">{/[a-z]/.test(password) ? '✓' : '○'}</span>
                  At least one lowercase letter (a-z)
                </li>
                <li className={/[0-9]/.test(password) ? 'met' : ''}>
                  <span className="checkmark">{/[0-9]/.test(password) ? '✓' : '○'}</span>
                  At least one number (0-9)
                </li>
                <li className={/[^A-Za-z0-9]/.test(password) ? 'met' : ''}>
                  <span className="checkmark">{/[^A-Za-z0-9]/.test(password) ? '✓' : '○'}</span>
                  At least one special character (!@#$%^&*)
                </li>
              </ul>
            </div>
            
            {/* Password Match Indicator */}
            {confirmPassword.length > 0 && (
              <div className={`password-match ${password === confirmPassword ? 'match' : 'no-match'}`}>
                {password === confirmPassword ? (
                  <>
                    <CheckCircle size={16} />
                    <span>Passwords match</span>
                  </>
                ) : (
                  <>
                    <AlertCircle size={16} />
                    <span>Passwords do not match</span>
                  </>
                )}
              </div>
            )}
            
            <button 
              type="submit" 
              className="submit-btn"
              disabled={loading || !password || !confirmPassword || password !== confirmPassword || passwordStrength < 3}
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;